// extracted by mini-css-extract-plugin
export var chevron = "_a1-2";
export var dropdownItems = "_a1-0";
export var item = "_a1-1";